import './App.css';
import Row from "./Row";
import requests from './request';
import Banner from './Banner.js';
import Nav from './Nav.js';

function App() {
  return (
    <div className="App">
      {/* Navbar */}
      <Nav/>
      {/* banner */}
      <Banner/>
        <Row title="NETFLIX ORIGINALS" fetchUrl={requests.fetchNetflixOriginals } isLargeRow />
        <Row title="Tending Now" fetchUrl={requests.fetchTrending}/>
        <Row title="Top Rated" fetchUrl={requests.fetchTopRated}/>
        <Row title="Action Movies" fetchUrl={requests.fetchActionMovies}/>
        <Row title="Comedy Movies" fetchUrl={requests.fetchComedyMovies}/>
        <Row title="Horror Movies" fetchUrl={requests.fetchRomancenMovies}/>
        <Row title="Documentary" fetchUrl={requests.fetchDocumentaries}/>

    </div>
  );
}

export default App;
